import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { RouteType } from "src/app/models/enum";
import { SharedService } from "src/app/shared/services/shared.service";

@Component({
	selector: "app-instructor-verification",
	templateUrl: "./instructor-verification.component.html",
	styleUrls: ["./instructor-verification.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class InstructorVerificationComponent implements OnInit {
	constructor(private sharedService: SharedService) {}

	ngOnInit(): void {
		this.sharedService.setActivePage(RouteType.INSTRUCTOR_VERIFICATION);
	}
}
